import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";
import { State } from "../state";
import styles from "./fraudPrevention.module.css";
import Seo from "./Seo";

interface GapItem {
  icon?: string;
  title?: string;
  problem?: string;
  solution?: string;
}

interface BenefitItem {
  title?: string;
  description?: string;
}

function FraudPrevention(): JSX.Element {
  const { data: languageData, appLanguage } = useSelector(
    (state: State) => state.languageReducer
  );
  const fraudText = languageData?.fraud ?? ({} as NonNullable<typeof languageData>["fraud"]);
  const isEnglish = appLanguage === "en";

  const labels = isEnglish
    ? { risk: "The risk", control: "How Shift Tracker closes it" }
    : { risk: "Risk", control: "Shift Tracker bunu nasıl kapatır" };

  const gaps: GapItem[] = fraudText.gaps?.items ?? [];
  const benefits: BenefitItem[] = fraudText.benefits?.items ?? [];

  return (
    <div className={styles.page}>
      <Seo path="/fraud-prevention" />

      <section className={styles.hero}>
        <h1 className={styles.title}>{fraudText.hero?.title}</h1>
        <p className={styles.subtitle}>{fraudText.hero?.subtitle}</p>
      </section>

      <section className={styles.intro}>
        <h2>{fraudText.intro?.title}</h2>
        <p>{fraudText.intro?.text}</p>
      </section>

      <section className={styles.gaps}>
        <div className={styles.sectionHeader}>
          <h2>{fraudText.gaps?.title}</h2>
          <p>{fraudText.gaps?.subtitle}</p>
        </div>

        <div className={styles.gapGrid}>
          {gaps.map((gap, index) => (
            <article key={index} className={styles.gapCard}>
              <div className={styles.gapIcon} aria-hidden="true">
                {gap.icon}
              </div>
              <h3 className={styles.gapTitle}>{gap.title}</h3>
              <p className={styles.gapRisk}>
                <span className={styles.riskLabel}>{labels.risk}</span>
                {gap.problem}
              </p>
              <p className={styles.gapControl}>
                <span className={styles.controlLabel}>{labels.control}</span>
                {gap.solution}
              </p>
            </article>
          ))}
        </div>
      </section>

      <section className={styles.benefits}>
        <h2>{fraudText.benefits?.title}</h2>
        <div className={styles.benefitsList}>
          {benefits.map((benefit, index) => (
            <div key={index} className={styles.benefitItem}>
              <h3>{benefit.title}</h3>
              <p>{benefit.description}</p>
            </div>
          ))}
        </div>
      </section>

      <section className={styles.cta}>
        <h2>{fraudText.cta?.title}</h2>
        <p>{fraudText.cta?.subtitle}</p>
        <NavLink to="/contact/" className={styles.ctaButton}>
          {fraudText.cta?.button}
        </NavLink>
      </section>
    </div>
  );
}

export default FraudPrevention;
